import { siteFlags } from "@/config/siteFlags";
import { BOOK_SECTION_ID } from "@/config/siteLinks";
export const Footer = () => {
  const year = new Date().getFullYear();
  const navLinks = [
    { l: "How it works", h: "#how-it-works" },
    { l: "Services", h: "#services" },
    { l: "Pricing", h: "#pricing" },
    ...(siteFlags.showTestimonials ? [{ l: "Testimonials", h: "#testimonials" }] : []),
    { l: "FAQ", h: "#faq" },
    { l: "Contact", h: "/contact" },
  ];
  return (    <footer data-testid="site-footer" className="bg-[#143628] text-[#F9F9F7]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-12 gap-y-12 gap-x-8">
          <div className="col-span-12 md:col-span-6">
            <p className="font-serif-display text-5xl sm:text-6xl tracking-tight">
              Job<em className="italic text-[#D4B886]">Nex</em>.
            </p>
            <p className="text-[#F9F9F7]/70 mt-6 max-w-md leading-relaxed">
              A hand-picked placement service for India&rsquo;s top 1% engineering talent. Quality candidates. Responsive HRs. Refund-backed.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="label-eyebrow text-[#D4B886] mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              {navLinks.map((i) => (                <li key={i.h}>
                  <a
                    href={i.h}
                    data-testid={`footer-link-${i.l.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[#F9F9F7]/80 hover:text-[#D4B886] transition-colors"
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="label-eyebrow text-[#D4B886] mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-[#F9F9F7]/80">
              <li>support@jobnex.co.in</li>
              <li>Bengaluru, India</li>
              <li>
                <a
                  href={`/#${BOOK_SECTION_ID}`}
                  data-testid="footer-cta-contact"
                  className="text-[#D4B886] border-b border-[#D4B886]/50 hover:border-[#D4B886] pb-px"
                >
                  Book a consultation
                </a>              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F9F9F7]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#F9F9F7]/60">
          <p>© {year} JobNex. All rights reserved.</p>
          <p>Built for engineers who&rsquo;d rather build than apply.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
